var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "details text" }, [
    _c("div", { staticClass: "column" }, [
      _vm._m(0),
      _vm._v(" "),
      _vm.mode === "nice"
        ? _c("p", [
            _vm._v(
              "\n            You can shout very loudly here:\n            "
            ),
            _c(
              "a",
              { staticClass: "link", attrs: { href: "tel:04 93 55 06 01" } },
              [_vm._v("\n                04 93 55 06 01\n            ")]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "column" }, [
      _c("p", [
        _vm._v("\n            Missioning a homing pigeon?\n            "),
        _c("br"),
        _vm._v(" "),
        _vm.mode === "nice"
          ? _c("strong", [
              _vm._v("\n                Indigen Solutions"),
              _c("br"),
              _vm._v("29 Rue Pastorelli"),
              _c("br"),
              _vm._v("06000 Nice,\n                France\n            "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.mode === "cairo"
          ? _c("strong", [
              _vm._v("\n                Indigen Middle East"),
              _c("br"),
              _vm._v("Al Matar, El Nozha,"),
              _c("br"),
              _vm._v(
                "Cairo\n                Governorate 11361, Egypt\n            "
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n            Show us some smoke at:\n            "),
      _c(
        "a",
        { staticClass: "link", attrs: { href: "mailto:contact@indigen.com" } },
        [_vm._v("\n                contact@indigen.com\n            ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }